import React from 'react'

import { Form } from '@react/react-spectrum/Form'

import { useProject } from 'hooks'

import DefaultBrandingForm from './forms/DefaultBrandingForm'
import JourneyTriggerBrandingForm from './forms/JourneyTriggerBrandingForm'
import MobileBrandingForm from './forms/MobileBrandingForm'
import MobileV2BrandingForm from './forms/MobileV2BrandingForm'
import CustomerExperienceBrandingForm from './forms/CustomerExperienceBrandingForm'
import CustomerExperienceV2BrandingForm from './forms/CustomerExperienceV2BrandingForm'
import WebModularBrandingForm from './forms/WebModularBrandingForm'
import SsrBrandingForm from './forms/SsrBrandingForm'
import CustomerHubBrandingForm from './forms/CustomerHubBrandingForm'

import './BrandingForm.scss'

const BrandingForm = () => {
  const { project, updateProjectPart, type, canEdit } = useProject()

  const onChange = (fieldName) => (value) => {
    updateProjectPart('branding', { ...branding, [fieldName]: value })
  }
  const onMetaChange = (fieldName) => (value) => {
    updateProjectPart('meta', { ...project.meta, [fieldName]: value })
  }

  const branding = project?.branding || {}

  let ProjectBrandingForm
  switch (type) {
    case 'mobile':
      ProjectBrandingForm = MobileBrandingForm
      break
    case 'mobile-v2':
      ProjectBrandingForm = MobileV2BrandingForm
      break
    case 'web-modular':
      ProjectBrandingForm = WebModularBrandingForm
      break
    case 'journey-trigger':
      ProjectBrandingForm = JourneyTriggerBrandingForm
      break
    case 'customer-experience':
      ProjectBrandingForm = CustomerExperienceBrandingForm
      break
    case 'customer-experience-v2':
      ProjectBrandingForm = CustomerExperienceV2BrandingForm
      break
    case 'ssr':
      ProjectBrandingForm = SsrBrandingForm
      break
    case 'customer-hub':
      ProjectBrandingForm = CustomerHubBrandingForm
      break
    default:
      ProjectBrandingForm = DefaultBrandingForm
  }

  return (
    <div className='branding-form'>
      <Form
        aria-labelledby='branding-form'
        onSubmit={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <ProjectBrandingForm
          branding={branding}
          project={project}
          onChange={onChange}
          onMetaChange={onMetaChange}
          disabled={!canEdit}
        />
      </Form>
    </div>
  )
}

export default BrandingForm
